import {Injectable} from '@angular/core';
import {DirtyStateTrackerInterface} from './dirty-state-tracker.interface';

@Injectable()
export class DirtyStateTrackerService implements DirtyStateTrackerInterface {
  public dirtyParentTracker: string[] = [];
  public dirtyChanged: Date;

  public isParentDirty(isDirty: boolean, parent: string): boolean {
    if (!isDirty) {
      return this.dirtyParentTracker.includes(parent);
    }
    return isDirty;
  }
}
